// ============================================================
// TMR Portal Admin — entregar um Blob ao navegador como arquivo
// ============================================================

/**
 * Hands the browser a file to save.
 *
 * The object URL is revoked on the next tick rather than immediately: Safari has to have started the
 * download before the URL goes away, and revoking in the same frame gives it a dead link. It is revoked
 * at all because an un-revoked object URL keeps the whole blob — a few thousand rows of XLSX — alive for
 * as long as the tab is open.
 *
 * @param blob The file's bytes.
 * @param fileName Name to save it under, extension included.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
